document.addEventListener( 'DOMContentLoaded', () => {
  const LocalDevTools = document.getElementById( 'LocalDevTools' );
  const ResponsiveVideos = document.querySelectorAll( '.responsive-video' );

  if ( !LocalDevTools ) return;

  const ResolutionSlot = LocalDevTools.querySelector( '#LocalDevToolsResolutionLog span' );

  let resizeTimeout;

  const handleResolutionDisplay = ( highlight = false ) => {
    ResolutionSlot.innerHTML = `${window.innerWidth} x ${window.innerHeight}`;

    if ( highlight ) {
      ResolutionSlot.parentNode.classList.add( 'highlight' );
    } else {
      ResolutionSlot.parentNode.classList.remove( 'highlight' );
    }
  }

  if ( LocalDevTools ) {
    window.addEventListener( 'resize', () => {
      handleResolutionDisplay( true );

      clearTimeout( resizeTimeout );
      resizeTimeout = setTimeout( () => {
        handleResolutionDisplay( false );
      }, 500 );
    } );

    handleResolutionDisplay();
  }

  if (ResponsiveVideos) {
    ResponsiveVideos.forEach(video => {
      const setSource = () => {
        while (video.firstChild) {
          video.removeChild(video.firstChild);
        }
        const source = document.createElement('source');
        source.src = (window.innerWidth > 768 ? video.dataset.d : video.dataset.m);
        source.type = 'video/mp4';
        video.appendChild(source);
        video.load();
      };

      setSource();

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          setSource();
        }, 250);
      });
    });
  }
} );
